import React from 'react';
import {Link} from 'react-router-dom';
import {DateTime} from 'components/UI/DateTime';
import {UploadImage} from 'components/UI/Image';

class SubNews extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="sub-news">
        <div className='sub-news-wrap'>
          <div className='sub-news-left-image'>
            <Link to={`/tin-tuc/${this.props.slug}/${this.props.id}`}>
              <UploadImage transform="crop" className='sub-news-img' width="180" height="108" type="ARTICLE" image={this.props.image}/>
            </Link>
          </div>
          <div className='sub-news-right-detail'>
            <h2 className='sub-news-title'><Link className='sub-news-title' to={`/tin-tuc/${this.props.slug}/${this.props.id}`}>{this.props.title}</Link></h2>
            <p className='sub-news-times'><DateTime dateTime={this.props.updatedAt}/></p>
            <p className='sub-news-desc'>{this.props.description}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default SubNews;



// WEBPACK FOOTER //
// ./components/news/SubNews.jsx